import { render, staticRenderFns } from "./IntroButton.vue?vue&type=template&id=5c50bc7e&"
import script from "./IntroButton.vue?vue&type=script&lang=js&"
export * from "./IntroButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports